module.exports = __webpack_public_path__ + "img/hockey.a134c42b.svg";